import Vue from 'vue'
import {
    DEVS_SET,
    DEV_UPDATE_PROP,
} from '../muations'

import _ from 'lodash'

const state = {
    all: {}
}

// getters
const getters = {
    /*getDevById: state => id => {
        if(Array.isArray(id)){
            return state.all.find(dev => id.includes(dev.id));
        } else {
            return state.all.find(dev => dev.id === id);
        }
    }*/
}

// actions
const actions = {

}

// mutations
const mutations = {
    [DEVS_SET] (state, devs) {
        _.forEach(devs, d => {
            Vue.set(state.all, d.id, d)
        })
    },

    [DEV_UPDATE_PROP] (state, {devId, prop, val}) {
        Vue.set(state.all[devId], prop, val)
    },

}


export default {
    // namespaced: true,
    state,
    getters,
    actions,
    mutations
}
